export { Intl } from './Intl'
export const t = (id, defaultMessage) => ({ id, defaultMessage})